import { Stack, Typography } from '@mui/material';

export const NoCampaigns = () => (
  <Stack
    spacing={2}
    direction="column"
    alignItems="center"
    justifyContent="center"
    id="no-campaigns"
    height="100%"
  >
    <Typography variant="h4">
      You do not have any campaigns. Let&apos;s get you one.
    </Typography>
    <Typography>
      Please email{' '}
      <a href="mailto:lcihotline@inmarket.com">lcihotline@inmarket.com</a> and
      an account manager will help create one for you.
    </Typography>
    <Typography>
      Note: If you already created a campaign it may take 1 week to show up.
    </Typography>
  </Stack>
);
